import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-900 text-white py-8 md:py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start space-x-3 mb-2">
              <img
                src="/logo-secondary.jpg"
                alt="Anders Ponds & Lakes - Tampa Bay Pond and Lake Management Services"
                className="w-10 h-10 rounded-md object-cover"
                width="40"
                height="40"
              />
              <h3 className="text-xl font-bold">Anders Ponds & Lakes</h3>
            </div>
            <p className="text-brand-200 text-sm">
              Preservation and Management of Freshwater Ecosystems
            </p>
          </div>

          {/* Contact Info - Prominent */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold mb-3">Contact Joe</h3>
            <div className="space-y-2">
              <a
                href="tel:+17272773366"
                className="block text-lg hover:text-brand-200 transition-colors min-h-[44px] flex items-center justify-center md:justify-start"
              >
                <span className="mr-2">📞</span>
                (727) 277-3366
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="block text-lg hover:text-brand-200 transition-colors break-all min-h-[44px] flex items-center justify-center md:justify-start"
              >
                <span className="mr-2">✉️</span>
                andersponds@gmail.com
              </a>
            </div>
          </div>

          {/* Our Work */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold mb-3">Our Work</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/projects"
                  className="text-brand-200 hover:text-white transition-colors block min-h-[44px] flex items-center justify-center md:justify-start"
                >
                  Tampa pond management
                </a>
              </li>
              <li>
                <a
                  href="/projects"
                  className="text-brand-200 hover:text-white transition-colors block min-h-[44px] flex items-center justify-center md:justify-start"
                >
                  St. Pete pond management
                </a>
              </li>
            </ul>
          </div>

          {/* Credentials */}
          <div className="text-center md:text-left lg:text-right">
            <h3 className="text-xl font-bold mb-2">Licensed & Insured</h3>
            <p className="text-brand-200 text-sm">
              Florida Department of Agriculture
            </p>
            <p className="text-brand-200 text-sm mt-2">
              Serving Greater Tampa Bay and St. Pete
            </p>

            {/* Social Media */}
            <div className="mt-4 pt-4 border-t border-brand-800">
              <a
                href="https://www.facebook.com/p/Anders-Ponds-Lakes-61577351702894/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center md:justify-end text-brand-300 hover:text-water-400 transition-colors"
                aria-label="Visit Anders Ponds on Facebook"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>

            <a
              href="/admin"
              rel="nofollow noopener"
              className="text-brand-400 text-xs mt-2 inline-block hover:text-brand-200 transition-colors"
            >
              Admin
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-brand-800 pt-6 text-center text-sm text-brand-300">
          <p>&copy; {currentYear} Anders Ponds & Lakes. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
